import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useMemo } from 'react';
import { useSwanListboxListContext } from './listbox-list.context.js';

var useSelectedItems = function useSelectedItems() {
  var _useSwanListboxListCo = useSwanListboxListContext(),
      listState = _useSwanListboxListCo.listState;

  var selectionManager = listState.selectionManager,
      collection = listState.collection;
  var selectedKeys = selectionManager.selectedKeys;
  var selectedItems = useMemo(function () {
    return _toConsumableArray(selectedKeys).map(function (key) {
      return collection.getItem(key);
    }).filter(Boolean);
  }, [selectedKeys, collection]); // if the first key is an item use it
  // otherwise, it's a section so iterate over the keys to find the first item
  // we could skip the firstKey check, but it might be slightly more performant

  var firstItem = useMemo(function () {
    var firstKey = collection.getFirstKey();
    var first;

    if (firstKey != null) {
      first = collection.getItem(firstKey);
    }

    if ((first === null || first === void 0 ? void 0 : first.type) !== 'item') {
      var _iterator = _createForOfIteratorHelper(collection.getKeys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var k = _step.value;
          var item = collection.getItem(k);

          if ((item === null || item === void 0 ? void 0 : item.type) === 'item') {
            first = item;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return first;
  }, [collection]);
  return useMemo(function () {
    return {
      selectedItems: selectedItems,
      selectedItemsOrFirst: selectedItems.length > 0 || !firstItem ? selectedItems : [firstItem]
    };
  }, [selectedItems, firstItem]);
};

export { useSelectedItems };